
import  {useEffect, useState} from 'react';  
import { Link, Navigate } from 'react-router-dom';
import paths from '../routes/paths';
import logo from "../assets/images/Logo.png";
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { logoutUser,getLoginDetails,loginModalOpen, loginModalClose } from '../redux/slices/AuthSlice';
import { fetchCartItems } from '../redux/slices/CartSlice';
import { fetchAppSettings } from '../redux/slices/SettingsSlice';
import { getCartId, getAuthToken, } from '../utils/auth';
import SideBarCart from './SideBarCart'
import { Tooltip } from 'react-tooltip'
import CustomerSupportIcon from '../components/svg/CustomerSupportIcon';
import {fetchGlobalSearchDetails } from '../redux/slices/CommonSlice';
import { globalSearchClose } from '../redux/slices/CommonSlice';
const  UserHeader = () => { 
    const [showCart, setShowCart] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);
    const [isFixed, setIsFixed] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState('Home');
    const [globalSearchTxt, setGlobalSearchTxt] = useState('');
    const [shopDropDown, setShopDropDown] = useState(false)
    const [shopDropDownContainer, setShopDropDownContainer] = useState('close')
    const {loggedInUser,wishlist_ids} = useSelector((state:any) => state.auth)
    const {cart} = useSelector((state:any) => state.cart)
    const {categories, hotDeals} = useSelector((state:any) => state.settings)
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    const token = getAuthToken();
    const [randomHotDeal, setRandomHotDeal] = useState([])
    const [days,setDays] =  useState<number>(0);
    const [mins,setMins] =  useState<number>(0);
    const [hrs,setHrs] =  useState<number>(0);
    const [secs,setSecs] =  useState<number>(0);
    const [searchErrors,setSearchErrors] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

    const handleLogout = () => {
      dispatch(logoutUser())
      return <Navigate replace={true} to="/" />
    }

  useEffect(() => {

    const cart_id = getCartId();
    cart_id !== null &&  cart_id !== '' && dispatch(fetchCartItems());
    dispatch(fetchAppSettings());

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener('scroll', handleScroll);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [dispatch]);

  useEffect(() => {
    const getLoggedinDetails = () => {
      //console.log("0 logged in user", loggedInUser, loggedInUser === null)
       // console.log("0 token", token)
        if(loggedInUser === null){
            if(token && token !== ''){
                dispatch(getLoginDetails())
            }
        }
      }
    getLoggedinDetails();
    
  },[loggedInUser,dispatch,token])

  useEffect(() => {
    hotDeals.length > 0 && setRandomHotDeal(hotDeals[Math.floor(Math.random() * hotDeals.length)]) 
  },[hotDeals]);

  useEffect(() => {
    /* Coming Soon Counter ============ */
      const handleComingSoonCounter = function () {
      var commingSoonDate = new Date().getTime() + (3*24*60*60*1000);
      const x = setInterval(function () {
        clockCounter(commingSoonDate,x);
      }, 1000);
    }

    handleComingSoonCounter()
  },[])


  const clockCounter = (commingSoonDate,x) => {
    var currentTime = new Date().getTime() ;
    var clockTime = commingSoonDate - currentTime;
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(clockTime / (1000 * 60 * 60 * 24));
    var hours = Math.floor((clockTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((clockTime % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((clockTime % (1000 * 60)) / 1000);

    var remainDays = (days.toString().length === 1) ? '0' + days : days;
    var remainHour = (hours.toString().length === 1) ? '0' + hours : hours;
    var remainMin = (minutes.toString().length === 1) ? '0' + minutes : minutes;
    var remainSeconds = (seconds.toString().length === 1) ? '0' + seconds : seconds;
    setDays(Number(remainDays));
    setHrs(Number(remainHour));
    setMins(Number(remainMin));
    setSecs(Number(remainSeconds)); 

   // var rotateNum = 6 * seconds;

    //$('.round').css({ 'transform': 'rotate(' + rotateNum + 'deg)' });
    //$('.round').css({ '-webkit-transform': 'rotate(' + rotateNum + 'deg)' });
    //$('.round').css({ '-o-transform': 'rotate(' + rotateNum + 'deg)' });
    //$('.round').css({ '-moz-transform': 'rotate(' + rotateNum + 'deg)' });
    //$('.round').css({ '-ms-transform': 'rotate(' + rotateNum + 'deg)' });

    // If the count down is over, write some text 
    if (clockTime < 0) {
      clearInterval(x);
      setDays(0);
      setHrs(0);
      setMins(0);
      setSecs(0); 
    }
  }

  // const handleLoginModalClose = () => {
  //   setLoginModalShow(false)
  // }
 
  const manageMenuSelection = (menu) => {
    setSelectedMenu(menu);
    setGlobalSearchTxt("");
    dispatch(globalSearchClose());
    setShopDropDownContainer("close");
    setShopDropDown(false);
    setMobileMenu(false);
  }
 
  const submitGlobalSearch = () => {
      if(globalSearchTxt === ''){
        setSearchErrors("Please enter Name or SKU.");
      }
      else{
        const selectedPage =1;
        dispatch(fetchGlobalSearchDetails({globalSearchTxt,selectedPage})); 
        setSearchErrors("");
      }  
  }
  //console.log("login user", randomHotDeal)

  const manageSubMenuSelection = () => {
    dispatch(globalSearchClose());
    setGlobalSearchTxt("");
    setShopDropDownContainer("close");
    setShopDropDown(false);
    setMobileMenu(false);
  }
  const manageHotDealsClick = () => {
    setShopDropDownContainer("close");
    setShopDropDown(false);
    setMobileMenu(false);
  }
  const manageShopClick = () => {
    setSelectedMenu("Shop");
    shopDropDown === true ? setShopDropDown(false) : setShopDropDown(true);
    shopDropDownContainer === "close" ? setShopDropDownContainer("open") : setShopDropDownContainer("close") ;
  }

  

//console.log("login modal", loginModalShow)
//console.log("hoot deal",randomHotDeal)
  return (

    <header className="site-header mo-left header style-2">		
      <div className="header-info-bar">
        <div className="container clearfix">
          <div className="logo-header logo-dark">
            <a href={paths.home}><img src={logo} alt="logo"/></a>
          </div>
          <div className="extra-nav d-md-flex d-none m-l15">
            <div className="extra-cell">
              <ul className="navbar-nav header-right m-0">
                <li className="nav-item info-box ">
                  <div className="nav-link">
                    <div className="dz-icon">			
                      <CustomerSupportIcon/>			
                    </div>
                    <div className="info-content">
                      <span>Whatsapp</span>
                      <h6 className="title mb-0">+91 84999 19988</h6>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
            
          <div className="header-search-nav">
            <form className='header-item-search'>
              <div className="input-group search-input"> 
                <input name="search_text" type="text" value={globalSearchTxt} onChange={(e) => setGlobalSearchTxt(e.target.value)} className="form-control" aria-label="Text input with dropdown button" placeholder="Search by Name or SKU..."/>
                <button className="btn" type="button" onClick={() => submitGlobalSearch() }>
                  <i className="iconly-Light-Search text-secondary"></i>
                </button>
              </div>
              {searchErrors !== '' && <p className='m-b-0 globalSearchMsg errorMsg text-md-start'>{searchErrors}</p>}

              </form>
          </div>
        </div>
      </div>

      <div className={"sticky-header main-bar-wraper navbar-expand-lg "+ (isFixed ? 'is-fixed' : '')}>
        <div className="main-bar clearfix">
          <div className="container clearfix d-lg-flex d-block">
            <div className="logo-header logo-dark">
              <a href="/"><img src={logo} alt="logo"/></a>
            </div>
            
            <button className={"navbar-toggler  navicon justify-content-end " + (mobileMenu === true ? "open" : "collapsed")} onClick={() => (mobileMenu === true ? setMobileMenu(false) : setMobileMenu(true))} type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span></span>
                <span></span>
                <span></span>
            </button>
              
            <div className={"header-nav w3menu navbar-collapse collapse justify-content-start " + (mobileMenu === true ? 'show' : '')} id="navbarNavDropdown">
              <div className="logo-header">
                <a href="/"><img src={logo} alt="logo"/></a>
              </div>
          
              <ul className="nav navbar-nav">
              <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Home' ? 'active' : '')} onClick={() => manageMenuSelection("Home")}> <Link to={paths.home} className=" text-900 ">Home</Link> </li> 

                <li className={"has-mega-menu sub-menu-down " + (shopDropDown === true ? "open " : " ") + (selectedMenu === 'Shop' ? 'active' : '')}>
                  <a href="#!" className={"shop-link " + (shopDropDown === true ? "open" : "")}  onClick={() => manageShopClick()}><span>Shop</span><i className="fa fa-chevron-down " ></i></a>
                  <div className={"mega-menu shop-menu " + shopDropDownContainer}>
                    <ul>
                      <li className="side-left">
                        <ul className="menu-list-header">
                          <li key="allSarees">
                              <Link to={paths.store} className=" menu-title ">All Sarees</Link>
                            <ul className={isMobile ? "mobile_menu" : ""}>
                              {categories.map((category) => 
                                <li key={"category_menu_" + category.slug}> 
                                  <Link to={paths.subCategories(category.slug)} onClick={() =>  manageSubMenuSelection()} className="stext-107 cl7 hov-cl1 trans-04">{category.name}</Link>
                                </li>
                              )}
                                
                            </ul>
                          </li> 
                          <li key="dealOfTheDay" className="month-deal">
                            <div className="clearfix me-3">
                              <h3>Deal of the day</h3>
                              <p className="mb-0"><b>Limited Time, Steal the Deal!</b> Get this stunning saree at an unbeatable price today <Link to={paths.offers} onClick={() => manageHotDealsClick()} className="dz-link-2">View Hot Deals</Link>  </p>
                            </div>
                            <div className="sale-countdown">
                              <div className="countdown text-center">
                                <div className="date">
                                  <span className="time days text-primary">{days}</span>
                                  <span className="work-time">Days</span>
                                </div>
                                <div className="date">
                                  <span className="time hours text-primary">{hrs}</span>
                                  <span className="work-time">Hours</span>
                                </div>
                                <div className="date">
                                  <span className="time mins text-primary">{mins}</span>
                                  <span className="work-time">Minutes</span>
                                </div>
                                <div className="date">
                                  <span className="time secs text-primary">{secs}</span>
                                  <span className="work-time">Second</span>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="side-right">
                        <div className="adv-media">
                            <img src={randomHotDeal && randomHotDeal['variants'] && randomHotDeal['variants'][0]['variant_images'] && (process.env.REACT_APP_SERVER_URL + randomHotDeal['variants'][0]['variant_images'][0].display_image_url)} alt="Hot Deal"/>
                            <div className="shop-card">
                              <div className="dz-content">
                                <h5 className="title">
                                  <Link to={paths.productDetails(randomHotDeal?.['id'])} className="stext-107 cl7 hov-cl1 trans-04">{randomHotDeal?.['name']}</Link>
                                </h5>
                                <h5 className="sku"> {randomHotDeal['variants'] && randomHotDeal['variants'][0]['sku']}</h5>
                                <h5 className="price"> {randomHotDeal['variants'] && randomHotDeal['variants'][0]['price']} <span className='strikedPrice'>{randomHotDeal['variants'] && randomHotDeal['variants'][0]['actual_price']}</span></h5> 
                                <Link to={paths.offers} onClick={() => manageHotDealsClick()} className="dz-link-2">View Hot Deals</Link>
                              </div>
                            </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
            
                <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Sarees' ? 'active' : '')} onClick={() => manageMenuSelection("Sarees")}> <Link to={paths.store} className=" text-900 ">Sarees</Link> </li> 
                <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Kurtas Kurtis' ? 'active' : '')} onClick={() => manageMenuSelection("Kurtas Kurtis")}> <Link to={paths.womenKurtasKurtis} className=" text-900 ">Kurtas & Kurtis</Link> </li> 
                <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Offers' ? 'active' : '')} onClick={() => manageMenuSelection("Offers")}> <Link to={paths.offers} className=" text-900 ">Hot Deals</Link> </li> 
                <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'Track Order' ? 'active' : '')} onClick={() => manageMenuSelection("Track Order")}> <Link to={paths.tracking} className=" text-900 ">Track Order</Link> </li> 
                {loggedInUser !== null && (
                  <li  className={"has-mega-menu sub-menu-down " + (selectedMenu === 'My Account' ? 'active' : '')} onClick={() => manageMenuSelection("My Account")}> <Link to={loggedInUser.loginType === "Customer" ? paths.userDashboard : paths.adminDashboard} className=" text-900 ">My Account</Link> </li> 
            
                )}

              </ul>
              
            </div>

            <div className="extra-nav">
              <div className="extra-cell">							
                <ul className="header-right">
                  
                
                {loggedInUser !== null && (
                  
                    <li className="nav-item login-link"> 
                        <a href="#!" onClick={() => handleLogout()} className=" text-900 cursor">  Logout  </a>
                    </li>
                  )}
                      
                    
                
                  {loggedInUser === null && (
                    <li className="nav-item login-link"> 
                      <button className='removeBtnBG' onClick={() => dispatch(loginModalOpen('User'))}>Login / Register</button>

                    </li>
                  )}
                  <li className="nav-item wishlist-link">
                    {loggedInUser === null && (
                      <button onClick={() => dispatch(loginModalClose())} className="nav-link removeBtnBG" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                        <i  data-tooltip-id="my-tooltip"  data-tooltip-content=" Wishlist"  className="iconly-Light-Heart2"></i>
                        <span className="badge badge-circle header_wishlist_count" >0</span>
                      </button>
                    )}
                      {loggedInUser !== null && loggedInUser.role === "User" && (
                      <Link to={paths.userWishlist}> 
                      <i className="iconly-Light-Heart2" data-tooltip-id="my-tooltip" data-tooltip-content="Wishlist" ></i>
                      <span className="badge badge-circle header_wishlist_count" >{wishlist_ids.length}</span>

                      </Link>
                    )}
                      
                  </li>
                  <li className="nav-item cart-link">
                      <button data-tooltip-id="my-tooltip"  data-tooltip-content="Cart" onClick={() => setShowCart(true)} className="nav-link cart-btn removeBtnBG"  data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                          <i className="iconly-Broken-Buy"></i>
                          <span className="badge badge-circle">{(cart && cart.line_items) ? cart.line_items.length : 0}</span>
                      </button>
                  </li> 
                </ul>
              </div>
            </div>
            <Tooltip id="my-tooltip" />

          </div>
        </div>
      </div>

      <div className="offcanvas dz-offcanvas offcanvas offcanvas-end "  id="offcanvasRight">
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
          &times;
        </button>
        <div className="offcanvas-body">
          <div className="product-description">
            <div className="dz-tabs">
              <ul className="nav nav-tabs center" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="shopping-cart" data-bs-toggle="tab" data-bs-target="#shopping-cart-pane" type="button" role="tab" aria-controls="shopping-cart-pane" aria-selected="true">Shopping Cart
                    <span className="badge badge-light header_cart_items_count">10</span>
                  </button>
                </li> 
              </ul>
              <div className="tab-content pt-4" id="dz-shopcart-sidebar">
                <div className="tab-pane fade show active" id="shopping-cart-pane" role="tabpanel" aria-labelledby="shopping-cart" >
                  <div id="mini_cart_items_list">
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div> 
  
      <SideBarCart showCart={showCart} onClose={() => setShowCart(false)}/>
    </header>
  );
}

export default UserHeader;

